import { StyleSheet, Platform } from 'react-native';
import Colors from '../../config/Colors';
import Layout from '../../config/Layout';

export default StyleSheet.create({
    header: {
        backgroundColor: Colors.white,
        display: 'flex',
        paddingTop: Platform.OS === 'ios' ? 16 : 0,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row'
    },
    headerBorderBottom: {
        borderBottomWidth: 1,
        borderBottomColor: Colors.border
    },
    iconBack: {
        paddingHorizontal: Layout.gutter,
        paddingVertical: 8
    },
    title: {
        flex: 2,
        fontSize: 18,
        marginTop: 4,
        color: Colors.dark
    },
    content: {
        flex: 2,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 8,
        height: 52
    },
    buttonSeparacao: {
        marginTop: 0
    },
    buttonCadastro: {
        marginTop: 0,
        marginRight: Layout.gutter,
        backgroundColor: Colors.secondary
    },
    buttonCancelar: {
        marginTop: 0,
        marginLeft: Layout.gutter,
        marginRight: Layout.gutter,
        backgroundColor: Colors.danger
    },
    addProdutoButton: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
    }
});
